import { useCallback } from 'react';
import { RichEditor } from '@odo/shared-ui';
import { uploadInternalImage } from '../../../services/internalImages';
import type { TiptapDoc } from '@odo/shared-ui';

interface InstructionsStepProps {
    patientId: string;
    value: TiptapDoc;
    onChange: (doc: TiptapDoc) => void;
}

function InstructionsStep({ patientId, value, onChange }: InstructionsStepProps) {
    const handleImageUpload = useCallback(
        async (file: File) => {
            const result = await uploadInternalImage(patientId, file, 'instructions');
            return { url: result.url, fileId: result.fileId };
        },
        [patientId]
    );

    return (
        <div className="flex-1 min-h-0 flex flex-col">
            <RichEditor
                value={value}
                onChange={onChange}
                onImageUpload={handleImageUpload}
                placeholder="Add clinical observations or special instructions for this case…"
                chrome="flush"
            />
        </div>
    );
}

export { InstructionsStep };
